import { createRouter, createWebHistory } from 'vue-router';
import {useAuthentication} from "@/pcm/plugins/authentication/authenticationPlugin";

const routes = [
    {
        path: '/',
        component: () => import('@/pcm/layouts/default/Default.vue'),
        children: [
            {
                path: '',
                name: 'dashboard',
                component: () => import('@/pcm/views/Dashboard.vue'),
            },

            {
                path: '/creators',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'creators.index', component: () => import('@/pcm/views/Creators/Index.vue') },
                    { path: ':creator/show', name: 'creators.show', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: ':creator/edit', name: 'creators.edit', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: ':creator/contracts', name: 'creators.contracts', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: ':creator/media', name: 'creators.media', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: ':creator/notes', name: 'creators.notes', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: ':creator/audit-trail', name: 'creators.audit_trail', component: () => import('@/pcm/views/Creators/Show.vue') },
                    { path: 'create', name: 'creators.create', component: () => import('@/pcm/views/Creators/Create.vue') },
                ]
            },

            {
                path: '/contracts',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'contracts.index', component: () => import('@/pcm/views/Contracts/Index.vue') },
                    { path: ':contract', name: 'contracts.show', component: () => import('@/pcm/views/Contracts/Show.vue') },
                    { path: ':contract/edit', name: 'contracts.edit', component: () => import('@/pcm/views/Contracts/Edit.vue') },
                ]
            },

            {
                path: '/clients',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'clients.index', component: () => import('@/pcm/views/Clients/Index.vue') },
                    { path: ':client', name: 'clients.show', component: () => import('@/pcm/views/Clients/Show.vue') },
                    { path: 'subscriptions/:subscription_client', name: 'subscription_clients.show', component: () => import('@/pcm/views/Clients/ShowSubscriptionClient.vue') },
                    { path: ':client/edit', name: 'clients.edit', component: () => import('@/pcm/views/Clients/Edit.vue') },
                    { path: 'create', name: 'clients.create', component: () => import('@/pcm/views/Clients/Create.vue') },
                ],
            },

            {
                path: '/account-changes',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'account-changes.index', component: () => import('@/pcm/views/AccountChanges/Index.vue') },
                    { path: ':client', name: 'account-changes.review', component: () => import('@/pcm/views/AccountChanges/Review.vue') },
                ],
            },

            {
                path: '/pages',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'pages.index', component: () => import('@/pcm/views/Pages/Index.vue') },
                    { path: ':page/edit', name: 'pages.edit', component: () => import('@/pcm/views/Pages/Edit.vue') },
                    { path: 'create', name: 'pages.create', component: () => import('@/pcm/views/Pages/Create.vue') },
                ],
            },

            {
                path: '/networks',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'networks.index', component: () => import('@/pcm/views/Networks/Index.vue') },
                    { path: ':network', name: 'networks.show', component: () => import('@/pcm/views/Networks/Show.vue') },
                    { path: ':network/edit', name: 'networks.edit', component: () => import('@/pcm/views/Networks/Edit.vue') },
                    { path: ':network/attach-media', name: 'networks.attach', component: () => import('@/pcm/views/Networks/AttachMedia.vue') },
                    { path: 'create', name: 'networks.create', component: () => import('@/pcm/views/Networks/Create.vue') },
                ]
            },

            {
                path: '/media',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'media.index', component: () => import('@/pcm/views/Library/Index.vue') },
                    { path: ':media', name: 'media.show', component: () => import('@/pcm/views/Library/Show.vue') },
                ]
            },

            {
                path: '/client-contracts',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    { path: '', name: 'client-contracts.index', component: () => import('@/pcm/views/ClientContracts/Index.vue') },
                    { path: ':client_contract', name: 'client-contracts.show', component: () => import('@/pcm/views/ClientContracts/Show.vue') },
                    { path: ':client_contract/edit', name: 'client-contracts.edit', component: () => import('@/pcm/views/ClientContracts/Edit.vue') },
                ]
            },

            {
                path: '/config',
                component: () => import('@/pcm/components/RouteGroup.vue'),
                children: [
                    {
                        path: '', name: 'config.index', component: () => import('@/pcm/views/Config/Index.vue')
                    },
                    {
                        path: 'categories',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.categories.index', component: () => import('@/pcm/views/Config/Categories/Index.vue') },
                            { path: ':category/edit', name: 'config.categories.edit', component: () => import('@/pcm/views/Config/Categories/Edit.vue') },
                            { path: 'create', name: 'config.categories.create', component: () => import('@/pcm/views/Config/Categories/Create.vue') },
                        ],
                    },
                    { path: 'my-profile', name: 'config.profile', component: () => import('@/pcm/views/Config/Profile.vue') },
                    {
                        path: 'tags',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.tags.index', component: () => import('@/pcm/views/Config/Tags/Index.vue') },
                            { path: ':tag/edit', name: 'config.tags.edit', component: () => import('@/pcm/views/Config/Tags/Edit.vue') },
                            { path: 'create', name: 'config.tags.create', component: () => import('@/pcm/views/Config/Tags/Create.vue') },
                        ],
                    },
                    { path: 'translations', name: 'config.translations', component: () => import('@/pcm/views/Config/Translations.vue') },
                    {
                        path: 'users',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.users.index', component: () => import('@/pcm/views/Config/Users/Index.vue') },
                            { path: ':user/edit', name: 'config.users.edit', component: () => import('@/pcm/views/Config/Users/Edit.vue') },
                            { path: 'create', name: 'config.users.create', component: () => import('@/pcm/views/Config/Users/Create.vue') },
                        ],
                    },
                    {
                        path: 'roles',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.roles.index', component: () => import('@/pcm/views/Config/Roles/Index.vue') },
                            { path: ':role/edit', name: 'config.roles.edit', component: () => import('@/pcm/views/Config/Roles/Edit.vue') },
                            { path: 'create', name: 'config.roles.create', component: () => import('@/pcm/views/Config/Roles/Create.vue') },
                        ],
                    },
                    {
                        path: 'platforms',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.platforms.index', component: () => import('@/pcm/views/Config/Platforms/Index.vue') },
                            { path: ':platform', name: 'config.platforms.show', component: () => import('@/pcm/views/Config/Platforms/Show.vue') },
                            { path: ':platform/edit', name: 'config.platforms.edit', component: () => import('@/pcm/views/Config/Platforms/Edit.vue') },
                            { path: 'create', name: 'config.platforms.create', component: () => import('@/pcm/views/Config/Platforms/Create.vue') },
                        ],
                    },
                    {
                        path: 'currencies',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.currencies.index', component: () => import('@/pcm/views/Config/Currencies/Index.vue') },
                            { path: ':currency/edit', name: 'config.currencies.edit', component: () => import('@/pcm/views/Config/Currencies/Edit.vue') },
                        ],
                    },
                    {
                        path: 'companies',
                        component: () => import('@/pcm/components/RouteGroup.vue'),
                        children: [
                            { path: '', name: 'config.companies.index', component: () => import('@/pcm/views/Config/Companies/Index.vue') },
                            { path: ':company/edit', name: 'config.companies.edit', component: () => import('@/pcm/views/Config/Companies/Edit.vue') },
                            { path: 'create', name: 'config.companies.create', component: () => import('@/pcm/views/Config/Companies/Create.vue') },
                        ],
                    },
                    { path: 'contract-imports', name: 'config.contract-imports', component: () => import('@/pcm/views/Config/ContractImports.vue') },
                    { path: 'media-imports', name: 'config.media-imports', component: () => import('@/pcm/views/Config/MediaImports.vue') },
                    { path: 'configure-media', name: 'config.configure-media', component: () => import('@/pcm/views/Config/ConfigureMedia.vue') },
                ],
            },
        ],
    },
    {
        path: '/auth',
        component: () => import('@/pcm/components/Authentication/Authentication.vue'),
        children: [
            { path: 'forgot-password', name: 'auth.forgot_password', component: () => import('@/pcm/views/Authentication/ForgotPassword.vue') },
            { path: 'login', name: 'auth.login', component: () => import('@/pcm/views/Authentication/Login.vue') },
            { path: 'reset-password', name: 'auth.reset_password', component: () => import('@/pcm/views/Authentication/ResetPassword.vue') },
            { path: 'user-setup', name: 'auth.user-setup', component: () => import('@/pcm/views/Authentication/UserSetupAccount.vue') },
            { path: 'client-setup', name: 'auth.client-setup', component: () => import('@/pcm/views/Authentication/ClientSetupAccount.vue') },
            { path: 'verify', name: 'auth.verify', component: () => import('@/pcm/views/Authentication/Verify.vue') },
        ]
    },

    // Catch all routes
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pcm/views/PathNotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(window.global.base),
    routes,
});

router.beforeEach((to, from, next) => {
    if ((to.path.startsWith('/auth') || to.path.startsWith('/app/auth')) && to.name !== 'auth.verify') {
        next();
    } else {
        useAuthentication().isLoggedIn(true)
            .then(() => {
                next();
            });
    }
});

export default router
